// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"366":"5adcc4ce","370":"e33d27ad","521":"e578af27","563":"c6942d8e","737":"d353043e","772":"a897521a","798":"d92321f4","828":"1ab9d2f3","839":"347714de","853":"c572834c"}[chunkId] + ".chunk.js";
};